import { expandSecondaryActionTouchArea } from "../../common/components/cdpaSecondaryActions";
import { Slugs } from "../../common/components/slug.loader";
import { getViewId, sendInteractionMetrics, trySendViewVisitMetrics } from "./formHelpers/metricsHelper";
import { ViewModuleMap } from "./formHelpers/viewModuleMap";
import { UIType } from "../../common/components/cdpaRequest";
import "../delete-account-cancel.scss";
import "./device-login.scss";
import "./info/info.scss";
import "./smart-login-conflict.scss";
class ModuleLoader {
    constructor() {
        const currentViewId = getViewId();
        if (currentViewId === undefined) {
            console.warn("Could not find viewId for the current view.");
            return;
        }
        const ViewModuleClass = ViewModuleMap[currentViewId];
        if (ViewModuleClass !== null) {
            window.OperationalModule = new ViewModuleClass();
        }
        if (window.OperationalModule === undefined) {
            console.debug(`No module associated with '${window.location.pathname}' path`);
        }
    }
}
window.onload = () => {
    Slugs.init();
    window.Loader = new ModuleLoader();
    expandSecondaryActionTouchArea();
    enableLanguageSelector();
    blurAnchorElementOnClick();
    trySendViewVisitMetrics();
};
const enableLanguageSelector = () => {
    const languageSelector = document.querySelector(".template__language-selector");
    if (languageSelector !== null) {
        languageSelector.addEventListener("click", () => {
            document.querySelector(".language-selector")?.classList.remove("language-selector--hidden");
            document.querySelector(".main-content")?.classList.add("main-content--hidden");
        });
    }
    const backButton = document.getElementsByClassName("language-back-button").item(0);
    if (backButton !== null) {
        backButton.addEventListener("click", () => {
            document.querySelector(".language-selector")?.classList.add("language-selector--hidden");
            document.querySelector(".main-content")?.classList.remove("main-content--hidden");
        });
    }
};
/**
 * Used to hide border around elements when clicking them with mouse
 */
const blurAnchorElementOnClick = () => {
    Array.from(document.getElementsByTagName("a")).forEach((element) => {
        element.addEventListener("click", () => {
            sendInteractionMetrics(element, UIType.Button);
            element.blur();
        });
    });
};
